module.exports = __webpack_public_path__ + "img/1.61ae2ba7.png";